import script from "./LoginFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginFooter.vue?vue&type=script&setup=true&lang=js"

import "./LoginFooter.vue?vue&type=style&index=0&id=8c5c733e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c5c733e"]])

export default __exports__